import { formatDateTime, timeAgo } from '../lib/format';

export function TimeAgo({ iso }: { iso?: string }) {
  if (!iso) return <span className="muted">never</span>;
  return (
    <time dateTime={iso} title={formatDateTime(iso)}>
      {timeAgo(iso)}
    </time>
  );
}
